'use client';

import useBrowser from '@/hooks/use-browser';

function ExcludingChrome({ children }) {
  const browser = useBrowser();

  if (browser === 'chrome') {
    return null;
  }

  return children;
}

export default ExcludingChrome;
